<header class="header">
  <nav>
    <h2>Simulador de formalización</h2>
    <img class="twoImg" src="/assets/images/escudo-2.png" alt="icon">
</nav>
</header>
